import { render, staticRenderFns } from "./DecisionModal.vue?vue&type=template&id=44b054a0&"
import script from "./DecisionModal.vue?vue&type=script&lang=js&"
export * from "./DecisionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports